import { useContext, useState } from 'react';
import { DataContext } from '../../data/DataContext';
import { ImgError, ImgOk } from '../../img';
import http from '../../../../services/http';
import { endPoints } from '../../../../utils/constanst';
import { ModalControl } from '../controls';
import { propLoading } from '../../data/Help';

const Step5 = () => {

    const { IH_CR } = useContext(DataContext);
    const [propModal, setPropModal] = useState(propLoading);

    const txt1Error = 'Pero no te preocupe, hemos recibido tus datos relacionados a la cotización';
    const txt2Error = 'En breve te contactaremos para confirmar la compra de tu póliza.';
    const txt3Error = 'Recordá tener a mano la tarjeta de crédito o débito con la que confirmarás la compra de tu póliza de Incendio Hogar.';

    const txt1OK = '¡Tu cotización esta lista!';
    const txt2OK = 'En breve recibirás en tu correo electrónico la oferta de seguros.';
    const txt3OK = 'Así mismo, nuestros ejecutivos te contactarán para confirmar la compra de su póliza, o bien nos podés contactar en nuestra central telefónica 2246- 2700, estamos para servirte de lunes a viernes de 8:00 a.m. a 5 p.m.';


    const downloadReport = () => {
        setPropModal({ ...propModal, active: true, txtMsg: 'Descargando' });
        http(endPoints.descargarOferta(IH_CR.numberPolicy))
            .get()
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setPropModal({ ...propModal, active: false });
            });
    }

    return (
        <>
            <div className='border-ihcr pt-20 pr-20 pl-20 mt-20'>
                {IH_CR.saved && <p className='lbl-end-ihcr-title'>
                    {txt1OK}
                </p>}
                {!IH_CR.saved && <p className='lbl-end-ihcr '>
                    {txt1Error}
                </p>}

                <div className='img-ihcr mt-40 mb-40'>
                    {IH_CR.saved && <ImgOk />}
                    {!IH_CR.saved && <ImgError />}
                </div>
                <p className='lbl-end-ihcr'>
                    {IH_CR.saved && txt2OK}
                    {!IH_CR.saved && txt2Error}
                </p>
                <p className='lbl-end-ihcr'>
                    {IH_CR.saved && txt3OK}
                    {!IH_CR.saved && txt3Error}
                </p>
                <div className='img-ihcr mt-30 mb-20'>
                    {IH_CR.saved && <button className='button-finish-ihcr-descargar' type='button' onClick={downloadReport}>Descargar cotización</button>}
                </div>
                <div className='img-ihcr mt-20 mb-50'>
                    <button className='button-finish-ihcr' onClick={() => window.location.reload()}>Finalizar</button>
                </div>
            </div>
            <ModalControl
                active={propModal.active}
                txtMsg={propModal.txtMsg}
            />
        </>
    );
}

export { Step5 };